import { render, staticRenderFns } from "./UserEpriredList.vue?vue&type=template&id=6a38f23a&"
import script from "./UserEpriredList.vue?vue&type=script&lang=js&"
export * from "./UserEpriredList.vue?vue&type=script&lang=js&"
import style0 from "./UserEpriredList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports